/**
 * @generated SignedSource<<b8a81e96db0c0f6bd6185ebb2a3238d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": true,
    "kind": "LocalArgument",
    "name": "includeService"
  }
],
v1 = [
  {
    "condition": "includeService",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "Service",
        "kind": "LinkedField",
        "name": "serviceById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "topServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "topServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "35492f2b59f6ecc9bc4f81114629e6d6",
    "id": null,
    "metadata": {},
    "name": "topServiceByIdQuery",
    "operationKind": "query",
    "text": "query topServiceByIdQuery(\n  $id: String\n  $includeService: Boolean = true\n) {\n  serviceById(id: $id) @include(if: $includeService) {\n    id\n    tags\n  }\n}\n"
  }
};
})();

node.hash = "422908da7f7065094dd7f2432e1be8ab";

module.exports = node;
